module.exports = __webpack_public_path__ + "fonts/righthand-hairlinedash-personal.7edfb490.ttf";